import {CheckoutNavigationService, ModalType} from '@wix/wixstores-client-storefront-sdk';
import {getCatalogAppIds} from './bi.utils';
import {CartModel} from '../models/Cart/Cart.model';

export const openNoOnlinePaymentsModal = async (
  checkoutNavigationService: CheckoutNavigationService,
  isEditorX: boolean,
  cartModel: CartModel
): Promise<void> => {
  const destination = cartModel.deliveryInfo?.address;
  const catalogAppId = getCatalogAppIds(cartModel);
  await checkoutNavigationService.openLegacyCartModal(
    ModalType.NoOnlinePayments,
    {destination, catalogAppId},
    isEditorX
  );
};
